import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@apexinternal/ui-components'
import React from 'react'
import { Box, Flex, Stack, Text } from '@chakra-ui/react'
import { AccountStatus, AccountStatusDisplay } from '../../../../types'

export interface ConfirmModalContentProps {
  accountStatus: AccountStatus
  reason: string
  onClose: () => void
  onConfirm: () => void
  onBack: () => void
}

const ConfirmModalContent = ({
  accountStatus,
  reason,
  onClose,
  onConfirm,
  onBack,
}: ConfirmModalContentProps) => {
  return (
    <ModalContent minWidth={'37.143rem'}>
      <ModalHeader>Confirm Third Party Trading Access Changes</ModalHeader>
      <ModalCloseButton onClick={onClose} />
      <ModalBody>
        <Stack spacing="1rem">
          <Text>
            Please review your changes to this account's trading access.
          </Text>
          <Box>
            <Text fontWeight="semibold">Trading Access</Text>
            <Text marginTop="0.5rem">
              {AccountStatusDisplay[accountStatus]}
            </Text>
          </Box>
          <Box>
            <Text fontWeight="semibold">Restriction Reason</Text>
            <Text marginTop="0.5rem">{reason}</Text>
          </Box>
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Flex width="100%" justifyContent={'space-between'}>
          <Button variant="link" onClick={onBack}>
            &lt; Back
          </Button>
          <Stack direction="row" spacing={2}>
            <Button variant="white" onClick={onClose} tabIndex={1}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onConfirm} tabIndex={2}>
              Submit Update
            </Button>
          </Stack>
        </Flex>
      </ModalFooter>
    </ModalContent>
  )
}

export default ConfirmModalContent
